<template>
  <article class="extra article" v-if="extra">
    <router-link :to="{ name: 'Post', params: { slug: extra.slug } }" class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
    </router-link>
    <div class="content">
      <router-link :to="{ name: 'Post', params: { slug: extra.slug } }"><h2 v-html="extra.title"></h2></router-link>
      <p><span v-html="extra.excerpt"></span> <router-link :to="{ name: 'Post', params: { slug: extra.slug } }" class="more-link">More</router-link></p>
      <div class="readModule">
        <router-link tag="button" :to="{ name: 'Post', params: { slug: extra.slug } }" class="readButton">
          <span>Read more</span>
        </router-link>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'extra-module',
  props: ['extra'],
  computed: {
    formattedDate () {
      return this.$moment(this.episode.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      if (vm.extra.image) {
        let image = vm.extra.image.large
        if (process.env.NODE_ENV === 'development') {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
        }
        return image
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

$sectionColor: $yellow

article
  padding: 32px 24px 78px
  background: white
  border-bottom: none
  position: relative
  margin-bottom: 34px
  border-top-color: $sectionColor
  +tablet
    width: 31.75%
  .image
    padding-bottom: 56.25%
    background: $sectionColor
    margin-bottom: 1.75rem
    background-size: cover
    background-position: center center
  .content
    h2
      font-size: 24px
      font-weight: bold
      &:hover
        color: lighten($textColor, 25%)
    .readModule
      padding: 0 24px
      position: absolute
      bottom: 24px
      left: 0
      right: 0
      &:after
        content: ''
        border-bottom: 8px solid $sectionColor
        position: absolute
        left: 0px
        right: 0px
        top: 50%
        transform: translateY(-25%)
      button
        display: block
        border: none
        background: $sectionColor
        text-align: center
        font-size: 18px
        padding: 0.5rem 1.5rem
        color: $textColor
        text-transform: uppercase
        font-weight: bold
        position: relative
        z-index: 1
        margin: auto
        cursor: pointer
        &:hover
          text-decoration: underline
</style>



// WEBPACK FOOTER //
// ExtraModule.vue?4d4f3ac1